let Fronter = ({ children }) => {
  return (
    <div className="fronter-main-div">
      <span>{children}</span>
    </div>
  );
};

export default Fronter;
